export default class SessionTimeoutInfo {
  constructor(private elapsedTime: number, private totalElapsedTime: number) {}

  public get elapsedTimePerCent() {
    return (100 * this.elapsedTime) / this.totalElapsedTime;
  }

  public ToString() {
    const minutes = Math.floor(this.elapsedTime / 60);
    return `${minutes}:${this.elapsedTime % (minutes * 60)}`;
  }
}
